module.exports = __webpack_public_path__ + "static/media/ant-transparent.0594832d.png";